import React from 'react';
import { Box, CircularProgress, Typography, keyframes } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface EndingScenarioOverlayProps {
  open: boolean;
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const EndingScenarioOverlay: React.FC<EndingScenarioOverlayProps> = ({ open }) => {
  const theme = useTheme();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        gap: 3,
      }}
    >
      <CircularProgress
        size={80}
        sx={{
          color: theme.palette.secondary.main,
          filter: `drop-shadow(0 0 30px ${alpha(theme.palette.secondary.main, 0.8)})`,
        }}
      />
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Space Mono", monospace',
          color: theme.palette.secondary.main,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          textShadow: `0 0 20px ${alpha(theme.palette.secondary.main, 0.6)}`,
        }}
      >
        Ending Scenario...
      </Typography>
      <Box
        sx={{
          width: '300px',
          height: '3px',
          background: `linear-gradient(90deg, transparent, ${theme.palette.secondary.main}, transparent)`,
          animation: `${fadeIn} 1.5s ease-in-out infinite`,
        }}
      />
    </Box>
  );
};
